import * as Actions from '../actions';

const initialState = {
    course: {
        is_loaded: false,
        company_calendar_course_id: 0,
        StartDate: '',
        EndDate: '',
        Unscheduled: 0,
        CourseName: '',
        CourseDescription: '',
        CourseEnrollmentDescription: '',
        CourseSizeLimit: 0,
        Color: '#ffffff',
        company_course_student_rel_id: 0,
        StudentCount: 0
    },
    prerequisites: [],
    courseLayout: [],
    instructors: [],
    prerequisites_complete: false
}

const courseEnrollmentReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_COMPANY_CALENDAR_COURSE_ENROLLMENT_DATA):
            {
                return {
                    ...state,
                    course: { ...state.course, ...action.payload }
                }
            }
        case (Actions.UPDATE_COURSE_LOADED):
            {
                return {
                    ...state,
                    course: { ...state.course, is_loaded: action.payload }
                }
            }
        case (Actions.GET_COURSE_PREREQUISITES):
            {
                return {
                    ...state,
                    prerequisites: action.payload
                }
            }
        case (Actions.GET_COURSE_LAYOUT):
            {
                return {
                    ...state,
                    courseLayout: action.payload
                }
            }
        case (Actions.GET_COURSE_INSTRUCTORS):
            {
                return {
                    ...state,
                    instructors: action.payload
                }
            }
        case (Actions.RESET_COURSE):
            {
                return {
                    ...initialState
                }
            }
        case (Actions.GET_STUDENT_REQUIRMENTS_MET):
            {
                return {
                    ...state,
                    prerequisites_complete: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default courseEnrollmentReducer;


// WEBPACK FOOTER //
// src/main/content/enrollment/store/reducers/courseEnrollment.reducer.js